export type ApiResponseOwner = {
  name: string,
  phoneNumber: string,
}

export class OwnerSummary {
  name: string;
  phoneNumber: string;

  constructor(apiResponseOwner: ApiResponseOwner) {
    this.name = apiResponseOwner.name;
    this.phoneNumber = apiResponseOwner.phoneNumber;
  }
}
